import { TYPE } from '../../constants/file-image-types';

export default function drawDeleteModalBody(id, name, type, path) {
  let html = `
        <div class="modal-content" data-grid-item-id='${id}'>
            <span>Are you sure you want to delete folder <b></b>?</span>
            <span>This action cannot be undone.</span>
        </div>
  `;
  
  if (type === TYPE.FOLDER_CONTENT) {
    html = `
        <div class="modal-content" data-grid-item-id='${id}'>
            <span>Are you sure you want to delete file <b></b>?</span>
            <span>This action cannot be undone.</span>
        </div>
  `;
  }

  if (type === TYPE.STOCK) {
    html = `
                <div class="modal-content" data-grid-item-id='${id}'>
                    <span>Are you sure you want to delete stock file <b></b>?</span>
                    <span>This action cannot be undone.</span>
          <input type="hidden" class="stock-image-path" id="stock-image-path" value="${path}" />
                </div>
    `;
  }

  const content = $(html);
  content.find('b').text(name);
  
  return content;
}